<template>
  <div>
    <v-app-bar app dark dense height="60" >
      <div class="navbar-flex-container">
        <!-- Imagen a la izquierda -->
        <v-img
          :src="$vuetify.breakpoint.lgAndUp ? require('../assets/logovinotinto.webp') : require('../assets/logovinotinto.webp')"
          :max-width="$vuetify.breakpoint.lgAndUp ? 260 : undefined"
          contain
          height="56"
        ></v-img>
        <!-- BottomNavigation centrado -->
        <div class="navbar-bottom-nav-container " v-if="$vuetify.breakpoint.lgAndUp">
          <BottomNavigation/>
        </div>
      </div>
    </v-app-bar>
  </div>
</template>


<script>
import { mapState } from "vuex";
import BottomNavigation from './BottomNavigation.vue';
export default {
  components: {
    BottomNavigation
  },
  data: () => ({
    drawer: false,
    group: null,
    snackbar: false,
    mensaje: "",
    admins: [
      ["Management", "mdi-account-multiple-outline"],
      ["Settings", "mdi-cog-outline"],
    ],
  }),

  computed: {
    ...mapState("users", ["user"]),
  },

  methods: {
    async doLogout() {
      try {
        await this.$store.dispatch("users/doLogout");
        this.$router.push({ name: "auth" });
        this.snackbar = true;
        this.mensaje = "Se cerró la sesión";
      } catch (error) {
        console.log(error);
      }
    },
    abrir_drawer() {
      this.drawer = true;
      window.scrollTo(0, 0);
      drawer = true;
    },
    ir_torneos() {
      this.$router.push("/torneos");
    },
    ir_juegos() {
      this.$router.push("/juegos");
    },
    ir_jugadores() {
      this.$router.push("/jugadores");
    },
    ir_jugadores_totales() {
      this.$router.push("/jugadores_acumulado");
    },
    ir_lideres() {
      this.$router.push("/lideres");
    },
    ir_lideres_juegos() {
      this.$router.push("/records_individuales");
    },
  },
};
</script>

<style scoped>
@media (min-width: 960px) {
  .v-application a {
    background-color: rgba(0, 0, 0, 0.25); /* Cambiado el valor de transparencia de 25% a 0.25 */
  }
}

.v-toolbar__title {
  min-width: 230px;
  font-size: 1.1rem;
}
.spacer {
  width: 100%;
}
.v-navigation-drawer {
  background-color: #7f182f !important;
}
.theme--light.v-list-item:not(.v-list-item--active):not(
    .v-list-item--disabled
  ) {
  color: #ffffff;
}
.v-application .primary--text {
  color: #ffffff !important;
  caret-color: #7f182f !important;
}

.v-toolbar--prominent:not(.v-toolbar--bottom) .v-toolbar__title {
  align-self: flex-start;
  padding-bottom: 0px;
  padding-top: 0px;
}

.v-toolbar__title[data-v-e0d06366] {
  min-width: 300px;
}

.v-list .v-list-item--active {
    color: #ffffff !important;
}
.navbar-flex-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  width: 100%;
}
.navbar-bottom-nav-container {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}
/*  .v-app-bar {
  position: relative;
  overflow: visible;
}  */ 
 .v-app-bar {
  position: fixed !important;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
}
</style>